module.exports = __webpack_public_path__ + "img/more_btn_txt.721552ce.svg";